import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getUser = (id) => {
  return axios.get(`${getBackendUrl()}/user/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

// export const getUsers = () => {
//   return axios.get(`${getBackendUrl()}/users`, {
//     headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//   });
// };

export const getUsers = (filter) => {
  return axios.request({
    method: "QUERY",
    url: `${getBackendUrl()}/users`,
    data: filter ? filter : {},
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
  });
};

export const getUsersLight = (ids) => {
  return axios.post(
    `${getBackendUrl()}/users/light`,
    { ids: ids },
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
};

export const editUser = (user) => {
  return axios.post(`${getBackendUrl()}/user`, user, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const changePasswordUser = (newPassword, oldPassword) => {
  return axios.post(
    `${getBackendUrl()}/user/changePassword`,
    { newPassword: newPassword, oldPassword: oldPassword },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const changePasswordAdmin = (userId, newPassword) => {
  return axios.post(
    `${getBackendUrl()}/user/${userId}/changePassword`,
    { newPassword: newPassword, oldPassword: "" },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const getCurrentUser = () => {
  return axios.get(`${getBackendUrl()}/user/current`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const register = (data) => {
  return axios.post(`${getBackendUrl()}/user/register`, data);
};

export const login = (email, password) => {
  return axios.post(`${getBackendUrl()}/user/login`, {
    email: email,
    password: password,
  });
};

export const removeUser = (id) => {
  return axios.delete(`${getBackendUrl()}/user/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const uploadAvatar = (file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(`${getBackendUrl()}/user/avatar`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const assignAward = (userId, awardId) => {
  return axios.post(
    `${getBackendUrl()}/user/award`,
    { userId, awardId },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const revokeAward = (userId, awardId) => {
  return axios.delete(`${getBackendUrl()}/user/${userId}/award/${awardId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const setUserIsActive = (userId, isActive) => {
  return axios.post(
    `${getBackendUrl()}/user/${userId}/${isActive}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};
